import React, {Component, PropTypes} from 'react'
import {Map, Record} from 'immutable'
import {createControlFactory} from 'components/Controls'
import CheckboxControl from 'components/CheckboxControl'
import ButtonControl from 'components/ButtonControl'
import Tip from 'components/TipControl'
import LiftControl from 'components/LiftControl'
import ActionCreators from 'actions/ActionCreators'
import {toMoneyFormat} from '../../../tools/number'
import IconSVG from 'svg-inline-react'
import isMobile from 'ismobilejs'
import classnames from 'classnames'
import ga from 'react-ga'

import './Options.scss'
import {AdditionalServiceItem} from "./AdditionalServiceItem";
import InstantBookingStore from "../../stores/InstantBookingStore";

class AdditionalService extends Component {
    
    static propTypes = {
        services: PropTypes.instanceOf(Map),
        selectedCategory: PropTypes.instanceOf(Record),
        selectedPartDay: PropTypes.instanceOf(Map),
        parameters: PropTypes.object,
        isSetLoaders: PropTypes.bool,
        onChangeService: PropTypes.func,
        dumpedLoaders: PropTypes.object,
        updatePrices: PropTypes.func,
        loadersExpanded: PropTypes.bool,
    }
    
    state = {
        loadersChecked: (this.props.parameters.load_loaders && this.props.parameters.load_loaders.get('value')) ||
            (this.props.parameters.unload_loaders && this.props.parameters.unload_loaders.get('value')),
        loadersErrors: [],
    }
    
    constructor(props) {
        super(props)
        this.Control = createControlFactory(ActionCreators.updateParameter)
    }

    componentWillMount() {
       /* document.addEventListener('click', this.handleLoadersExpandedClickOutside, false);*/
    }

    componentWillReceiveProps(nextProps) {
        const loadersChecked = (nextProps.parameters.load_loaders && nextProps.parameters.load_loaders.get('value')) ||
            (nextProps.parameters.unload_loaders && nextProps.parameters.unload_loaders.get('value'))
        
        if (this.state.loadersChecked !== loadersChecked) {
            ActionCreators.updateParameter({
                loaders: loadersChecked,
            })
            
            if (!loadersChecked) {
                ActionCreators.updateParameter({
                    packing_services: false,
                    dismantling_assembling_furniture: false,
                })
            }
            
            this.props.onChangeService({attribute: nextProps.parameters['loaders'].set('value', loadersChecked)})
        }
        
        this.setState({
            loadersChecked,
        })
    }

/*    componentWillUnmount(){
        document.removeEventListener('click', this.handleLoadersExpandedClickOutside, false);
    }*/

    _parseOptions = (options) => {
        return Object.values(options).map(option => {
            return {
                value: option.id,
                label: option.value,
            }
        })
    }

    onClickEditLoaders = e => {
        e.preventDefault()
        
        ga.event({
            category: 'clicks',
            action: 'instant_booking_edit_load_services',
            label: this.props.selectedCategory.get('name'),
            value: 1,
        })

        ActionCreators.setLoadersExpanded(true);
        ActionCreators.setInstantBookingLoadersSaved(false)
    }
    
    onChangeLoaders = (e, checked) => {
        this.setState({
            loadersChecked: checked,
        })

        ActionCreators.setLoadersExpanded(checked);
        ActionCreators.dumpInstantBookingLoaders(checked)

        if (checked) {
            ActionCreators.setInstantBookingLoadersSaved(false)

            if (this.props.dumpedLoaders) {
                ActionCreators.updateParameter({
                    ...this.props.dumpedLoaders,
                })
            } else {
                ActionCreators.updateParameter({
                    loaders: true,
                    load_loaders: true,
                    unload_loaders: true,
                    load_elevator: [],
                    unload_elevator: [],
                    load_floor: undefined,
                    unload_floor: undefined,
                    packing_services: false,
                    dismantling_assembling_furniture: false,
                })
            }
            
            const escortMax = this.getEscortMaxValue(checked)
            const escort = this.props.parameters.escort && this.props.parameters.escort.value ? this.props.parameters.escort.value : 0
            
            if (escort > escortMax) {
                ActionCreators.updateParameter({
                   escort: escortMax,
                })
            }
        } else {
            ActionCreators.setInstantBookingLoadersSaved(true)
            ActionCreators.updateParameter({
                loaders: false,
                load_loaders: false,
                unload_loaders: false,
                load_elevator: [],
                unload_elevator: [],
                load_floor: undefined,
                unload_floor: undefined,
                packing_services: false,
                dismantling_assembling_furniture: false,
            })
        }
        
        this.props.onChangeService({attribute: this.props.parameters['loaders'].set('value', checked)})
    }

    closeLoaders = () => {
        ActionCreators.dumpInstantBookingLoaders(false)

        ActionCreators.updateParameter({
            loaders: false,
            load_loaders: false,
            unload_loaders: false,
            load_elevator: [],
            unload_elevator: [],
            load_floor: undefined,
            unload_floor: undefined,
            packing_services: false,
            dismantling_assembling_furniture: false,
        })

        this.setState({
            loadersChecked: false,
            loadersErrors: [],
        })

        ActionCreators.setLoadersExpanded(false);
        ActionCreators.setInstantBookingLoadersSaved(true);
    }

/*    handleLoadersExpandedClickOutside = (event) => {
        if (!this.refs.LoadersExpanded.contains(event.target)) {
            this.closeLoaders();
        }
    }*/
    
    onLoadChange = (event) => {
        ActionCreators.updateParameter({
            load_floor: event.floor,
            load_elevator: event.type,
            load_loaders_count: event.loadersCount,
        })
    }
    
    onUnloadChange = (event) => {
        ActionCreators.updateParameter({
            unload_floor: event.floor,
            unload_elevator: event.type,
            unload_loaders_count: event.loadersCount,
        })
    }
    
    toggleLiftControl = (type, disabled) => {
        if (disabled && type === 'load') {
            ActionCreators.updateParameter({
                load_floor: undefined,
                load_elevator: [],
            })
        }
        
        if (disabled && type === 'unload') {
            ActionCreators.updateParameter({
                unload_floor: undefined,
                unload_elevator: [],
            })
        }
        
        switch (type) {
            case 'load':
                ActionCreators.updateParameter({
                    load_loaders: !disabled,
                })
                break
            case 'unload':
                ActionCreators.updateParameter({
                    unload_loaders: !disabled,
                })
                break
        }
    }
    
    parseLoadersOptions = (options) => {
        return Object.values(options).map(option => {
            return {
                value: option.id,
                label: option.value,
            }
        })
    }

    submitLoaders = () => {
        const errors = []
        const loadLoadersChecked = this.props.parameters.load_loaders
            && this.props.parameters.load_loaders.get('value')
        const unloadLoadersChecked = this.props.parameters.unload_loaders
            && this.props.parameters.unload_loaders.get('value')

        const loadLoadersCount = this.props.parameters.load_loaders_count
            && this.props.parameters.load_loaders_count.get('value');
        const unloadLoadersCount = this.props.parameters.unload_loaders_count
            && this.props.parameters.unload_loaders_count.get('value');

        let loadElevatorValue = 0
        let unloadElevatorValue = 0

        if (this.props.parameters.load_elevator.value) {
            loadElevatorValue = parseInt(this.props.parameters.load_elevator.value, 10)
        }

        if (this.props.parameters.unload_elevator.value) {
            unloadElevatorValue = parseInt(this.props.parameters.unload_elevator.value, 10)
        }

        if (loadLoadersChecked) {
            if (!this.props.parameters.load_floor.value) {
                errors.push('Укажите верный этаж погрузки')
            }

            if (!loadElevatorValue) {
                errors.push('Укажите наличие лифта на погрузке')
            }

            if (!loadLoadersCount) {
                errors.push('Укажите количество грузчиков на погрузке');
            }
        }

        if (unloadLoadersChecked) {
            if (!this.props.parameters.unload_floor.value) {
                errors.push('Укажите верный этаж выгрузки')
            }

            if (!unloadElevatorValue) {
                errors.push('Укажите наличие лифта на выгрузке')
            }

            if (!unloadLoadersCount) {
                errors.push('Укажите количество грузчиков на выгрузке');
            }
        }

        if (errors.length === 0) {
            this.props.updatePrices()
            this.setState({
                loadersErrors: [],
            })

            ActionCreators.setLoadersExpanded(false);
            ActionCreators.setInstantBookingLoadersSaved(true)
        } else {
            this.setState({
                loadersErrors: errors,
            })
        }
    }

    getEscortMaxValue = (loadersChecked = false) => {
        const loadersCount = this.props.services.get('price_loader') ? this.props.services.get('price_loader').count_loader : 2
        
        if (loadersChecked) {
            if (loadersCount === 1) {
                return 1
            }
            
            if (loadersCount === 2) {
                return 0
            }
            
            if (loadersCount > 2) {
                return 0
            }
        }
        
        return 999
    }

    getReduce = (isActive) => {
        const unloadElevator = this.props.parameters.unload_elevator;
        const loadElevator = this.props.parameters.load_elevator;

        const unloadLoadersOptions = this.props.parameters.unload_loaders_count.values
        const loadLoadersOptions = this.props.parameters.load_loaders_count.values

        let unloadElevatorOptions = null;
        let loadElevatorOptions = null;
        let loadElevatorValue = 0
        let unloadElevatorValue = 0

        if (unloadElevator && loadElevator) {
            unloadElevatorOptions = unloadElevator.values
            loadElevatorOptions = loadElevator.values

            if (this.props.parameters.load_elevator.value && this.props.parameters.load_elevator.value.length > 0) {
                loadElevatorValue = parseInt(this.props.parameters.load_elevator.value[0], 10)
            }

            if (this.props.parameters.unload_elevator.value && this.props.parameters.unload_elevator.value.length > 0) {
                unloadElevatorValue = parseInt(this.props.parameters.unload_elevator.value[0], 10)
            }
        }

        const selectedPartDayPrice = this.props.selectedPartDay.valueSeq().get(0) ? this.props.selectedPartDay.valueSeq().get(0).price : 0;

        return Object.keys(this.props.parameters).reduce((result, key) => {
            const parameter = this.props.parameters[key]

            if (parameter.get('name') === 'packing_services' || parameter.get('name') === 'dismantling_assembling_furniture') {
                return result;
            }

            if ((parameter.get('price') === undefined || parameter.get('price') == 0) &&
                (parameter.get('price_coef') === undefined || parameter.get('price_coef') == 0)) {
                return result
            } else {
                const wrapperClassnames = classnames({
                    'Options-valueBar': true,
                    'Options-valueLoadersBar': parameter.get('name') === 'loaders',
                    'Options-wrap': parameter.get('name') === 'escort',
                    'selectedService': parameter.get('value'),
                })

                const titleClassnames = classnames({
                    'Options-titleLoaders': parameter.get('name') === 'loaders',
                })

                const valueClassnames = classnames({
                    'Options-value': true,
                    'Options-valueEscort': parameter.get('name') === 'escort',
                })

                let tip = null
                let parameterValueRendered = null
                let iconRender = null

                switch (parameter.get('name')) {
                    case 'loaders':
                        parameterValueRendered = (
                            <div className="Options-controlLoaders">
                                <CheckboxControl
                                    label=""
                                    name="loaders"
                                    value={this.state.loadersChecked}
                                    onChange={this.onChangeLoaders}/>
                            </div>
                        )

                         tip = (
                             <a onClick={this.onClickEditLoaders} className="loadersSettingIcon">
                                 <IconSVG src={require('!svg-inline!./settings-icon.svg')}/>

                                 {!isMobile.phone &&
                                    <Tip
                                        className="Options-innerTip"
                                        label="Укажите этаж погрузки&nbsp;и&nbsp;выгрузки"/>
                                 }
                             </a>
                         )

                        iconRender = (
                            <IconSVG
                                key={`${parameter.get('name')}-${key}-1`}
                                className="Parameter-Icon"
                                src={require('!svg-inline!./Icons/Loader/Default.svg')}
                                title={parameter.get('title')}/>
                        )

                        break
                    case 'escort':
                        parameterValueRendered = (
                            <div className="Options-counterEscort">
                                <this.Control
                                    type="number"
                                    attribute={parameter}
                                    label=""
                                    minValue={0}
                                    maxValue={this.getEscortMaxValue(this.state.loadersChecked)}
                                    name={parameter.get('name')}
                                    onChange={this.props.onChangeService}/>
                            </div>
                        )

                         if (!isMobile.phone) {
                             tip = (
                                 <Tip
                                     className="Options-tipEscort"
                                     label={parameter.get('tip')}/>
                             )
                         }

                        iconRender = (
                            <IconSVG
                                key={`${parameter.get('name')}-${key}-1`}
                                className="Parameter-Icon"
                                src={require('!svg-inline!./Icons/Add-extra-sit/Default.svg')}
                                title={parameter.get('title')}/>
                        )

                        break

                    case 'round_trip':
                        parameterValueRendered = (
                            <this.Control
                                type="checkbox"
                                label=""
                                attribute={parameter}
                                onChange={this.props.onChangeService}/>
                        )

                        iconRender = (
                            <IconSVG
                                className="Parameter-Icon"
                                src={require('!svg-inline!./Icons/Round-trip/Default.svg')}
                                title={parameter.get('title')}/>
                        )

                        break

                    default:
                        parameterValueRendered = (
                            <this.Control
                                type="checkbox"
                                label=""
                                attribute={parameter}
                                onChange={this.props.onChangeService}/>
                        )
                }

                if ((isActive && parameter.get('value')) || (!isActive && !parameter.get('value'))) {
                    const packingServices = this.props.parameters['packing_services'];
                    const fixServices = this.props.parameters['dismantling_assembling_furniture'];

                    result.push(
                        <div key={parameter.get('name')} className={wrapperClassnames}>
                            <div className={'Options-title ' + titleClassnames}>
                                {iconRender}
                                {parameter.get('title')}
                                {tip}
                            </div>
                            <div className={valueClassnames}>
                                {parameter.get('price_coef') ?
                                    <div className="Options-valueLabel">
                                        +{toMoneyFormat(Math.ceil((parameter.get('price_coef') * selectedPartDayPrice) - selectedPartDayPrice))}₽
                                    </div> :
                                    <div className="Options-valueLabel">
                                        +{toMoneyFormat(parameter.get('price'))}₽
                                    </div>
                                }
                                {parameterValueRendered}
                            </div>
                            {/*<div className="Options-valueBarLoaders">*/}
                            {parameter.get('name') === 'loaders' &&
                                <div>
                                    <div className="loaders-additionalService">
                                        <AdditionalServiceItem
                                            keyProp={'packing-services'}
                                            iconKey={`packing-services-1`}
                                            parameterService={packingServices}
                                            selectedPartDayPrice={selectedPartDayPrice}
                                            disabled={!this.state.loadersChecked}
                                            onChangeService={this.props.onChangeService}
                                            iconSrc={require('!svg-inline!./Icons/Packaging/Default.svg')}
                                        />
                                        <AdditionalServiceItem
                                            keyProp={'dismantling-assembling-furniture'}
                                            iconKey={`fix-services-1`}
                                            parameterService={fixServices}
                                            selectedPartDayPrice={selectedPartDayPrice}
                                            disabled={!this.state.loadersChecked}
                                            onChangeService={this.props.onChangeService}
                                            iconSrc={require('!svg-inline!./Icons/Fix/Default.svg')}
                                        />
                                    </div>

                                {this.props.loadersExpanded &&
                                <div
                                    className="Options-valueBarLoaders">
                                    {/*<AnimakitExpander duration={100} expanded={this.state.loadersExpanded}>*/}
                                        <button className="Options-closeValueBarLoaders" onClick={this.closeLoaders}/>

                                        {this.state.loadersErrors.length > 0 ?
                                            <div className="Options-errorBar">
                                                {
                                                    this.state.loadersErrors.map((error, index) => {
                                                        return (
                                                            <div key={index}>{error}</div>
                                                        )
                                                    })
                                                }
                                            </div> : null}

                                        <LiftControl
                                            className="Options-liftParamsfield"
                                            label="На погрузке"
                                            onChange={this.onLoadChange}
                                            floor={this.props.parameters.load_floor.value}
                                            type={loadElevatorValue}
                                            options={this.parseLoadersOptions(loadElevatorOptions)}
                                            loadersOptions={this._parseOptions(loadLoadersOptions)}
                                            disableControl={!this.props.parameters.load_loaders.value}
                                            toggleLiftControl={this.toggleLiftControl.bind(this, 'load')}/>
                                        <LiftControl
                                            className="Options-liftParamsfield"
                                            label="На выгрузке"
                                            onChange={this.onUnloadChange}
                                            floor={this.props.parameters.unload_floor.value}
                                            type={unloadElevatorValue}
                                            options={this.parseLoadersOptions(unloadElevatorOptions)}
                                            loadersOptions={this._parseOptions(unloadLoadersOptions)}
                                            disableControl={!this.props.parameters.unload_loaders.value}
                                            toggleLiftControl={this.toggleLiftControl.bind(this, 'unload')}/>
                                        <ButtonControl
                                            className="Options-saveLoadersButton"
                                            view="blueLink"
                                            size="s"
                                            onClick={this.submitLoaders}>
                                            OK
                                        </ButtonControl>
                                    {/*</AnimakitExpander>*/}
                                </div>}
                                </div>
                            }
                        </div>,
                    )
                }
                return result
            }
        }, [])
    };
    
    render() {
        return (
            <div className="Options">
                {/*<div className="Options-labelBox">
                    <div className="Options-label">Дополнительные услуги <br/> и грузчики</div>
                    <div className="Options-includedInPriceBox">
                        <div className="Options-includedInPriceStick">✓</div>
                        <div className="Options-includedInPrice">Входит <br/>в стоимость</div>
                    </div>
                </div>*/}
                <div className="Options-additionalService">
                   {/* <div key="driver_help" className="Options-valueBar selectedService">
                        <div className="Options-title">
                            <IconSVG
                                key="driver_help"
                                className="Parameter-Icon"
                                src={require('!svg-inline!./Icons/Driver-help/Default.svg')}
                                title="Помощь водителя"/>

                            Помощь водителя
                            {
                                !isMobile.phone &&
                                <Tip
                                    className="Options-tipEscort"
                                    label="Вы тоже можете помочь на погрузке и выгрузке"/>
                            }
                        </div>
                        <div className="Options-value">
                            <div className="Options-valueLabel">0&nbsp;₽</div>
                            <CheckboxControl
                                label=""
                                disabled
                                name="driver_help"
                                value={true}
                                onChange={e => e.preventDefault()}/>
                        </div>
                    </div>*/}
                   {/* <div key="insurance" className="Options-valueBar selectedService">
                        <div className="Options-title">
                            <IconSVG
                                key="insurance"
                                className="Parameter-Icon"
                                src={require('!svg-inline!./Icons/Insurance/Default.svg')}
                                title="Страхование груза"/>

                            <div>Страхование груза до 100&nbsp;000&nbsp;₽</div>
                        </div>
                        <div className="Options-value">
                            <div className="Options-valueLabel">0&nbsp;₽</div>
                            <CheckboxControl
                                label=""
                                disabled
                                name="insurance"
                                value={true}
                                onChange={e => e.preventDefault()}/>
                        </div>
                    </div>*/}

                    {this.getReduce(true)}
                    {this.getReduce(false)}
                </div>
            </div>
        )
    }
}

export default AdditionalService



// WEBPACK FOOTER //
// ./client/components/InstantBookingScreen/AdditionalService.js